import cabine from '../../../services/cabineApi';
import { gotErrorFromApi } from '../../../utils/api';
import {
  getApurationFromApi,
  gotApurationFromApi,
  gotErrorFromApurationApi,
} from '../../duck/legado/apurationApp';
import { SendLoginTokenAuth } from '../tokens';

function getApurationAccounts(
  partner: Number,
  initialDate: Date | String,
  finalDate: Date | String
) {
  return (dispatch: any) => {
    dispatch(getApurationFromApi());
    cabine
      .get(
        `v1/legado/relatorio/contas/${partner}/${initialDate}/${finalDate}`,
        SendLoginTokenAuth()
      )
      .then((response: any) => {
        dispatch(gotApurationFromApi(response.data));
      })
      .catch((error: any) => {
        gotErrorFromApi(error, dispatch, gotErrorFromApurationApi);
      });
  };
}

export default getApurationAccounts;
